(() => {
  if (customElements.get('ad-product-3d')) return;
  let enginePromise;
  const loadEngine = () => {
    if (customElements.get('model-viewer')) return Promise.resolve();
    if (enginePromise) return enginePromise;
    enginePromise = new Promise((resolve, reject) => {
      let fallbackStarted = false;
      let script;
      const timer = setTimeout(() => {
        script?.remove();
        reject(new Error('engine-timeout'));
      }, 30000);
      const ready = () => customElements.whenDefined('model-viewer').then(() => {
        clearTimeout(timer);
        resolve();
      });
      const fallback = () => {
        if (fallbackStarted) return;
        fallbackStarted = true;
        if (customElements.get('model-viewer')) { ready(); return; }
        script = document.createElement('script');
        script.type = 'module';
        script.src = 'https://ajax.googleapis.com/ajax/libs/model-viewer/4.1.0/model-viewer.min.js';
        script.onload = ready;
        script.onerror = () => {
          clearTimeout(timer);
          script.remove();
          reject(new Error('engine-module-load'));
        };
        document.head.append(script);
      };
      fallback();
    }).catch((error) => { enginePromise = undefined; throw error; });
    return enginePromise;
  };

  customElements.define('ad-product-3d', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.poster = this.querySelector('[data-model-open]');
      this.mount = this.querySelector('[data-model-mount]');
      this.closeButton = this.querySelector('[data-model-close]');
      this.status = this.querySelector('[data-model-status]');
      this.poster.addEventListener('click', () => this.open());
      this.closeButton.addEventListener('click', () => this.close());
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && this.active) { event.stopPropagation(); this.close(); }
      });
    }

    disconnectedCallback() { this.close(false); }

    async open() {
      if (this.active) return;
      document.querySelectorAll('ad-product-3d').forEach((other) => {
        if (other !== this && other.active) other.close(false);
      });
      this.active = true;
      delete this.dataset.modelError;
      this.setAttribute('aria-busy', 'true');
      this.poster.disabled = true;
      this.closeButton.hidden = false;
      this.status.textContent = this.dataset.loadingLabel;
      const attempt = this.attempt = {};
      try {
        await loadEngine();
        if (this.attempt !== attempt || !this.isConnected) return;
        const viewer = this.querySelector('template').content.firstElementChild.cloneNode(true);
        viewer.removeAttribute('auto-rotate');
        viewer.addEventListener('load', () => {
          if (this.attempt !== attempt) return;
          clearTimeout(this.loadTimer);
          this.removeAttribute('aria-busy');
          this.poster.hidden = true;
          this.status.textContent = this.dataset.readyLabel;
          viewer.focus({preventScroll: true});
        }, {once: true});
        viewer.addEventListener('error', (event) => this.fail(attempt, event.detail?.type || 'model-load'), {once: true});
        this.loadTimer = setTimeout(() => this.fail(attempt, 'model-timeout'), 60000);
        this.mount.replaceChildren(viewer);
        this.mount.hidden = false;
      } catch (error) { this.fail(attempt, error.message || 'viewer-error'); }
    }

    fail(attempt, reason) {
      if (this.attempt !== attempt) return;
      this.close(false);
      this.dataset.modelError = reason || 'unknown';
      this.status.textContent = this.dataset.errorLabel;
      this.poster.focus({preventScroll: true});
    }

    close(focus = true) {
      this.active = false;
      this.attempt = null;
      clearTimeout(this.loadTimer);
      this.removeAttribute('aria-busy');
      if (!this.mount) return;
      this.mount.replaceChildren();
      this.mount.hidden = true;
      this.poster.disabled = false;
      this.poster.hidden = false;
      this.closeButton.hidden = true;
      this.status.textContent = '';
      if (focus) this.poster.focus({preventScroll: true});
    }
  });
})();
